// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U9xuJjrdOVkSW8 {
  position: relative;
  padding: var(--ds-space-100, 8px);
  padding-left: var(--ds-space-400, 32px);
}
.nnWeP4tkLPlq7s {
  position: absolute;
  top: var(--ds-space-075, 5px);
  left: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var listItem = `U9xuJjrdOVkSW8`;
export var checkIcon = `nnWeP4tkLPlq7s`;
export default ___CSS_LOADER_EXPORT___;
